module.exports = __webpack_public_path__ + "img/services-icon-6.5af9f449.png";